import httpClient from '@/http-client'

export const getTask = (Options = {}) => {
  return httpClient
    .get('/api/v1/project-management/home/tasks', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getTask
}
